import * as Bowser from 'bowser';
import FingerprintJS, { GetResult } from '@fingerprintjs/fingerprintjs';
import moment from 'moment';

import { toNameValueIfExists } from 'scenes/common/helpers/marshal';
import { WireNameValue } from 'scenes/common/api/quote/types';
import { MetadataName } from '../types/metadata.types';

const {
  browser: { name: browserName, version: browserVersion },
  os: { name: osName },
} = Bowser.parse(window.navigator.userAgent);
let result: GetResult;

(async () => {
  // We recommend to call `load` at application startup.
  const fp = await FingerprintJS.load();

  // The FingerprintJS agent is ready.
  // Get a visitor identifier when you'd like to.
  result = await fp.get();
})();

const getDateTime = () =>
  moment(new Date()).format('YYYY-MM-DDTHH:mm:ss.SSSZZ');

const getFingerprintId = (): WireNameValue[] =>
  toNameValueIfExists(
    MetadataName.FingerprintID,
    process.env.REACT_APP_FAKE_FINGERPRINT ?? result.visitorId
  );

export const getInitialMetaData = (): WireNameValue[] => [
  ...toNameValueIfExists(
    MetadataName.InitialBrowserName,
    process.env.REACT_APP_FAKE_INITIAL_BROWSERNAME ?? browserName
  ),
  ...toNameValueIfExists(
    MetadataName.InitialBrowserVersion,
    process.env.REACT_APP_FAKE_INITIAL_BROWSERVERSION ?? browserVersion
  ),
  ...toNameValueIfExists(
    MetadataName.InitialOSVersion,
    process.env.REACT_APP_FAKE_INITIAL_OS ?? osName
  ),
  ...getFingerprintId(),
];

let quoteCompleteCounter = 0;
export const getQuoteCompleteMetadata = (): WireNameValue[] => {
  quoteCompleteCounter += 1;

  return [
    {
      name: MetadataName.QuoteCompleteCount,
      value:
        process.env.REACT_APP_FAKE_QUOTE_COMPLETE_COUNT ??
        quoteCompleteCounter.toString(),
    },
    {
      name: MetadataName.QuoteCompleteDateTime,
      value:
        process.env.REACT_APP_FAKE_QUOTE_COMPLETE_DATE_TIME ?? getDateTime(),
    },
    ...getFingerprintId(),
  ];
};

let policyDetailsCounter = 0;
export const getPolicyDetailsMetadata = (): WireNameValue[] => {
  policyDetailsCounter += 1;

  return [
    {
      name: MetadataName.PolicyDetailsCount,
      value:
        process.env.REACT_APP_FAKE_THANK_YOU_COUNT ??
        policyDetailsCounter.toString(),
    },
    {
      name: MetadataName.PolicyDetailsDateTime,
      value: process.env.REACT_APP_FAKE_THANK_YOU_DATE_TIME ?? getDateTime(),
    },
    ...getFingerprintId(),
  ];
};

let paymentCounter = 0;
export const getConfirmAndPayMetadata = (): WireNameValue[] => {
  paymentCounter += 1;

  return [
    {
      name: MetadataName.ConfirmAndPayCount,
      value:
        process.env.REACT_APP_FAKE_QUOTE_COMPLETE_COUNT ??
        paymentCounter.toString(),
    },
    {
      name: MetadataName.ConfirmAndPayDateTime,
      value:
        process.env.REACT_APP_FAKE_QUOTE_COMPLETE_DATE_TIME ?? getDateTime(),
    },
    ...toNameValueIfExists(
      MetadataName.LatestBrowserName,
      process.env.REACT_APP_FAKE_FINAL_BROWSERNAME ?? browserName
    ),
    ...toNameValueIfExists(
      MetadataName.LatestBrowserVersion,
      process.env.REACT_APP_FAKE_FINAL_BROWSERVERSION ?? browserVersion
    ),
    ...toNameValueIfExists(
      MetadataName.LatestOSVersion,
      process.env.REACT_APP_FAKE_FINAL_OS ?? osName
    ),
    ...getFingerprintId(),
  ];
};

// Not sure where to use them
/*
export const getThankYouMetadata = (): WireNameValue[] => [
  {
    name: 'FTY',
    value: process.env.REACT_APP_FAKE_THANK_YOU_COUNT ?? '0',
  },
  {
    name: 'FTYDT',
    value:
      process.env.REACT_APP_FAKE_THANK_YOU_DATE_TIME ??
      getDateTime(),
  },
  getFingerprintId(),
];
*/
